import script from "./ShakyoInputCSV.vue?vue&type=script&setup=true&lang=js"
export * from "./ShakyoInputCSV.vue?vue&type=script&setup=true&lang=js"

import "./ShakyoInputCSV.vue?vue&type=style&index=0&id=05410a53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05410a53"]])

export default __exports__